import MemoryCard from './MemoryCard';

export default MemoryCard;
